import { DefaultButton, PrimaryButton } from '@fluentui/react';
import { Link } from '@fluentui/react';
import React from 'react';
import { useNavigate } from 'react-router-dom';

export enum RouteLinkType {
    Link = 'link',
    DefaultButton = 'defaultButton',
    PrimaryButton = 'primaryButton',
}

interface IRouteLinkProps {
    to: string;
    action?: (() => boolean) | (() => Promise<boolean>);
    disabled?: boolean;
    linkType: RouteLinkType;
    style?: {};
    children?: React.ReactNode;
}

const RouteLink: React.FC<IRouteLinkProps> = (props) => {
    const { to, disabled, linkType, style, children, action } = props;
    const navigate = useNavigate();

    const clickHandler = (ev: React.MouseEvent<HTMLButtonElement>) => {
        const route = ev.currentTarget.getAttribute('href') || '#';
        ev.preventDefault();

        const actionResult = action ? action() : true;
        if (actionResult instanceof Promise) {
            actionResult.then((success) => {
                if (success) {
                    navigate(route);
                }
            });
        } else if (actionResult) {
            navigate(route);
        }
    };

    const linkTags: { [key: string]: React.ComponentType<any> } = {
        link: Link,
        defaultButton: DefaultButton,
        primaryButton: PrimaryButton,
    };

    const LinkTag: React.ComponentType<any> = linkTags[linkType];
    return (
        <LinkTag href={to} onClick={clickHandler} disabled={disabled} style={style}>
            {children}
        </LinkTag>
    );
};

export default RouteLink;
